import React from 'react';
import PropTypes from 'prop-types';
import { getAvatarStyle } from '../../lib/s3';

const ProfilePicture = ({
  pictureUrl,
  userName,
  userIsStudent,
  userCompanyEnabledStudentProfiles,
  userCompanyStudentWord,
  userHasTeam,
  companySettings,
}) => {
  const avatarStyle = getAvatarStyle(pictureUrl, companySettings);

  return (
    <div style={{ position: 'relative', display: 'inline-block' }}>
      <a>
        <img
          src={avatarStyle.url}
          alt={userName}
          className="avatar"
          style={{
            backgroundColor: avatarStyle.backgroundColor,
            ...(avatarStyle.isNewStyle ? { objectFit: 'contain', objectPosition: 'bottom center', transform: 'scale(0.85)', transformOrigin: 'bottom center' } : {}),
          }}
        />
      </a>
      {userIsStudent && userCompanyEnabledStudentProfiles && (
        <figure className="ribbon" style={{ backgroundColor: '#333333' }}>{userCompanyStudentWord}</figure>
      )}
      {userHasTeam && (
        <figure className="ribbon" style={{ backgroundColor: '#333333' }}>Team</figure>
      )}
    </div>
  );
};

ProfilePicture.propTypes = {
  pictureUrl: PropTypes.string,
  userName: PropTypes.string,
  userHasTeam: PropTypes.bool,
  companySettings: PropTypes.shape({
    avatar_background_color: PropTypes.string,
    avatar_directory: PropTypes.string,
    primary_color: PropTypes.string,
  }),
};

ProfilePicture.defaultProps = {
  pictureUrl: '',
  userName: '',
  userHasTeam: false,
  companySettings: {},
};

export default ProfilePicture;
